<template>
  <div class="d-flex align-items-center min-vh-100">
    <CContainer>
      <div class="col-12 p-0">
        <CCard class="col-4 tablet-bg-8 mx-auto card--custom animate__animated animate__fadeIn">
          <CCardBody>
            <div class="card-header mb-4 pb-0">
              <h5 class="text-center mb-4">Registro Proveedores</h5>
            </div>
            <form action="" class="">
              <div class="form-group relative group--custom">
                <input
                  type="text"
                  class="form-control input--custom"
                  placeholder="Nombre de pila"
                />
              </div>
              <div class="form-group relative group--custom">
                <input
                  type="text"
                  class="form-control input--custom"
                  placeholder="Número celular (10 dígitos)"
                />
              </div>
              <div class="form-group relative group--custom">
                <input
                  type="email"
                  class="form-control input--custom"
                  placeholder="Correo electrónico"
                />
              </div>
              <div class="form-group relative group--custom">
                <input
                  type="password"
                  class="form-control input--custom"
                  placeholder="Contraseña"
                />
              </div>
              <div class="form-group relative group--custom">
                <input
                  type="password"
                  class="form-control input--custom"
                  placeholder="Repite tu contraseña"
                />
              </div>
              <div
                class="form-group checkbox__group d-flex align-items-start mt-3"
              >
                <input id="terms" type="checkbox" class="" />
                <label for="tems" class="d-block ml-1"
                  >Acepto <a href="">Términos y condiciones</a> y
                  <a href="">Aviso de privacidad</a>
                </label>
              </div>
              <div class="form-group mt-4 d-flex">
                <router-link to="verifiacion" class="btn btn-primary--custom flex-grow-1"
                  >Registrarme</router-link
                >
              </div>
              <div class="card-footer text-center">
                <div>
                  <p class="mt-3 mb-0">¿Ya tienes cuenta?</p>
                  <router-link
                    to="login"
                    class="text-primary--custom text-underline"
                    >Ingresa</router-link
                  >
                </div>
              </div>
            </form>
          </CCardBody>
        </CCard>
      </div>
    </CContainer>
  </div>
</template>

<script>
export default {
  name: "Register",
  methods: {
    register() {
      this.$router.push({ path: "/dashboard" });
    },
  },
};
</script>
